export default __webpack_public_path__ + "2f1372f5a1b6188d48b91c44b59f84c7.png";